module.exports = __webpack_public_path__ + "files/01dfb37105f4b7f22ea281416e020d60.png";